import axios from "axios";
export const CLEAR_POST_RES = "CLEAR_POST_RES";
export const CLEAR_SEARCHED_ESTABLECIMIENTO = "CLEAR_SEARCHED_ESTABLECIMIENTO";
export const POST_SEARCHED_RES = "POST_SEARCHED_RES";
export const GET_DATOS_ESTABLECIMIENTOS = "GET_DATOS_ESTABLECIMIENTOS";
export const CLEAR_RES = "CLEAR_RES";
export const GET_VALIDAR_DISPONIBILIDAD_RESOLUCION =
  "GET_VALIDAR_DISPONIBILIDAD_RESOLUCION";
export const GET_FORMULARIO_ANTERIOR = "GET_FORMULARIO_ANTERIOR";
export const GET_FORMULARIOS_PRESENTADOS = "GET_FORMULARIOS_PRESENTADOS";
export const POST_ALL_RES = "POST_ALL_RES";
export const POST_OBSERVACIONES_RES = "POST_OBSERVACIONES_RES";
export const POST_CABECERA_RES = "POST_CABECERA_RES";
export const ADD_SUSTANCIA = "ADD_SUSTANCIA";
export const REMOVE_SUSTANCIAS = "REMOVE_SUSTANCIAS";
export const ADD_DOSIMETRIA = "ADD_DOSIMETRIA";
export const SET_EQUIPO_RADIOLOGICO = "SET_EQUIPO_RADIOLOGICO";
export const ADD_PROTECCION_RADIOLOGICA = "ADD_PROTECCION_RADIOLOGICA";
export const ADD_RESPONSABLE_INSTALACION = "ADD_RESPONSABLE_INSTALACION";
export const ADD_RESPONSABLE_USO = "ADD_RESPONSABLE_USO";
export const REMOVE_DOSIMETRIA = "REMOVE_DOSIMETRIA";
export const REMOVE_RESPUSO = "REMOVE_RESPUSO";
export const REMOVE_RESPINST = "REMOVE_RESPINST";
export const REMOVE_PROTRAD = "REMOVE_PROTRAD";
export const ADD_EQUIPO_RADIOLOGICO = "ADD_EQUIPO_RADIOLOGICO";
export const GET_SUSTANCIAS = "GET_SUSTANCIAS";
export const GET_UNIDADES_MEDIDA = "GET_UNIDADES_MEDIDA";
export const GET_EQUIPOS_RADIOLOGICOS = "GET_EQUIPOS_RADIOLOGICOS";
export const GET_TIPOS_METODOS_PROCESAMIENTO =
  "GET_TIPOS_METODOS_PROCESAMIENTO";
export const GET_TIPOS_FUENTES = "GET_TIPOS_FUENTES";
export const GET_TIPOS_EQUIPOS_RADIOLOGICOS = "GET_TIPOS_EQUIPOS_RADIOLOGICOS";
export const GET_TIPOS_CARACTERISTICAS = "GET_TIPOS_CARACTERISTICAS";
export const GET_TIPOS_RADIACION = "GET_TIPOS_RADIACION";
export const POST_EQUIPO_RADIOLOGICO = "POST_EQUIPO_RADIOLOGICO";
export const GET_METODOS_PROCESAMIENTO = "GET_METODOS_PROCESAMIENTO";
export const GET_TIPOS_DOSIMETRIA = "GET_TIPOS_DOSIMETRIA";
export const GET_METODOS_DOSIMETRIA = "GET_METODOS_DOSIMETRIA";
export const POST_DOSIMETRIA = "POST_DOSIMETRIA";
export const ADD_PROVEEDOR = "ADD_PROVEEDOR";
export const REMOVE_PROVEEDOR = "REMOVE_PROVEEDOR";
export const ADD_ESTUDIO_AMBIENTAL = "ADD_ESTUDIO_AMBIENTAL";
export const REMOVE_ESTUDIO_AMBIENTAL = "REMOVE_ESTUDIO_AMBIENTAL";
export const GET_TIPOS_ESTUDIO = "GET_TIPOS_ESTUDIO";
export const GET_FRECUENCIAS_ESTUDIO = "GET_FRECUENCIAS_ESTUDIO";
export const GET_METODOLOGIAS_EMPLEADAS = "GET_METODOLOGIAS_EMPLEADAS";
export const GET_USOS_ORIGEN = "GET_USOS_ORIGEN";
export const GET_MODOS_EMPLEO = "GET_MODOS_EMPLEO";
export const ADD_USOS = "ADD_USOS";
export const REMOVE_USOS = "REMOVE_USOS";
export const REMOVE_EQUIPO_RADIOLOGICO = "REMOVE_EQUIPO_RADIOLOGICO";
export const GET_DATOS_EQUIPO_RADIOLOGICO_ESTABLECIMIENTO =
  "GET_DATOS_EQUIPO_RADIOLOGICO_ESTABLECIMIENTO";
export const SET_EQUIPO_RADIOLOGICO_DATA = "SET_EQUIPO_RADIOLOGICO_DATA";
export const POST_METODOLOGIA_EMPLEADA = "POST_METODOLOGIA_EMPLEADA";
export const ADD_DATOS_SUSTANCIA = "ADD_DATOS_SUSTANCIA";
export const SET_EDIT_SUSTANCIA = "SET_EDIT_SUSTANCIA";
export const ADD_CONTRATISTA = "ADD_CONTRATISTA";
export const EDIT_CONTRATISTA = "EDIT_CONTRATISTA";
export const DELETE_CONTRATISTA = "DELETE_CONTRATISTA";
export const GET_CIIU = "GET_CIIU";

export const ADD_EMPRESA = "ADD_EMPRESA";
export const EDIT_EMPRESA = "EDIT_EMPRESA";
export const DELETE_EMPRESA = "DELETE_EMPRESA";
export const ADD_PUESTOS_ASOCIADOS = 'ADD_PUESTOS_ASOCIADOS';
export const REMOVE_PUESTOS = 'REMOVE_PUESTOS';
export const GET_PUESTOS = 'GET_PUESTOS';
export const GET_DATOS_CIOU_PUESTO = 'GET_DATOS_CIOU_PUESTO';
export const GET_MEDIDAS_PREVENTIVAS = 'GET_MEDIDAS_PREVENTIVAS';
export const GET_ELEMENTOS_PROTECCION_PERSONAL = 'GET_ELEMENTOS_PROTECCION_PERSONAL';
export const ADD_TRABAJADORES = 'ADD_TRABAJADORES';
export const REMOVE_TRABAJADORES = 'REMOVE_TRABAJADORES';
export const GET_SECTORES = 'GET_SECTORES';
export const GET_TIPOS_EXAMENES_MEDICOS = 'GET_TIPOS_EXAMENES_MEDICOS';
export const GET_FORMULARIO_POR_ID = "GET_FORMULARIO_POR_ID";


// Action Creators
export const addContratista = (values) => (dispatch) => {
  return dispatch({
    type: ADD_CONTRATISTA,
    payload: values,
  });
};

export const editContratista = (values) => (dispatch) => {
  return dispatch({
    type: EDIT_CONTRATISTA,
    payload: values,
  });
};

export const deleteContratista = (id) => (dispatch) => {
  return dispatch({
    type: DELETE_CONTRATISTA,
    payload: id,
  });
};

export const addEmpresa = (values) => (dispatch) => {
  return dispatch({
    type: ADD_EMPRESA,
    payload: values,
  });
};

export const editEmpresa = (values) => (dispatch) => {
  return dispatch({
    type: EDIT_EMPRESA,
    payload: values,
  });
};

export const deleteEmpresa = (id) => (dispatch) => {
  return dispatch({
    type: DELETE_EMPRESA,
    payload: id,
  });
};
export const setEditSustancia =
  (values, id = null) =>
    (dispatch) => {
      return dispatch({
        type: SET_EDIT_SUSTANCIA,
        payload: { values, id },
      });
    };

export const addDatosSustancia = (values) => (dispatch) => {
  return dispatch({
    type: ADD_DATOS_SUSTANCIA,
    payload: values,
  });
};

export const postMetodologiaEmpleada = (values) => (dispatch) => {
  return dispatch({
    type: POST_METODOLOGIA_EMPLEADA,
    payload: axios
      .post("cancerigeno/cargarMetodologiaEmpleada", values)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getCIIU = (values) => (dispatch) => {
  return dispatch({
    type: GET_CIIU,
    payload: axios
      .get("afiliaciones/actividades", values)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getDatosEquipoRadiologicoEstablecimiento = (id) => (dispatch) => {
  return dispatch({
    type: GET_DATOS_EQUIPO_RADIOLOGICO_ESTABLECIMIENTO,
    payload: axios
      .get(
        `cancerigeno/datosEquipoRadiologicoEstablecimiento?idEquipoRadiologicoEstablecimiento=${id}`
      )
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const addUsos = (values, id = null) => ({
  type: ADD_USOS,
  payload: { values, id },
});

export const removeUsos = (id) => ({
  type: REMOVE_USOS,
  payload: id,
});

export const getModosEmpleo = () => (dispatch) => {
  return dispatch({
    type: GET_MODOS_EMPLEO,
    payload: axios
      .get("cancerigeno/modosEmpleo")
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getUsosOrigen = () => (dispatch) => {
  return dispatch({
    type: GET_USOS_ORIGEN,
    payload: axios
      .get("cancerigeno/usosOrigen")
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getMetodologiasEmpleadas = (idTipoEstudio) => (dispatch) => {
  return dispatch({
    type: GET_METODOLOGIAS_EMPLEADAS,
    payload: axios
      .get(`cancerigeno/metodologiasEmpleadas?idTipoEstudio=${idTipoEstudio}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getFrecuenciasEstudio = () => (dispatch) => {
  return dispatch({
    type: GET_FRECUENCIAS_ESTUDIO,
    payload: axios
      .get("cancerigeno/frecuenciasEstudio")
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getTiposEstudio = () => (dispatch) => {
  return dispatch({
    type: GET_TIPOS_ESTUDIO,
    payload: axios
      .get("cancerigeno/tiposEstudio")
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const addEstudioAmbiental = (values, id = null) => ({
  type: ADD_ESTUDIO_AMBIENTAL,
  payload: { values, id },
});

export const removeEstudioAmbiental = (id) => ({
  type: REMOVE_ESTUDIO_AMBIENTAL,
  payload: id,
});

export const addProveedor = (values, id = null) => ({
  type: ADD_PROVEEDOR,
  payload: { values, id },
});

export const removeProveedor = (id) => ({
  type: REMOVE_PROVEEDOR,
  payload: id,
});

export const removeDosimetria = (idToRemove) => ({
  type: REMOVE_DOSIMETRIA,
  payload: idToRemove,
});

export const removeRespUso = (idToRemove) => ({
  type: REMOVE_RESPUSO,
  payload: idToRemove,
});

export const removeRespInst = (idToRemove) => ({
  type: REMOVE_RESPINST,
  payload: idToRemove,
});

export const removeProtRad = (idToRemove) => ({
  type: REMOVE_PROTRAD,
  payload: idToRemove,
});

export const addEquipoRadiologico =
  (values, id = null) =>
    (dispatch) => {
      return dispatch({
        type: ADD_EQUIPO_RADIOLOGICO,
        payload: { values, id },
      });
    };

export const addDosimetria =
  (values, id = null) =>
    (dispatch) => {
      return dispatch({
        type: ADD_DOSIMETRIA,
        payload: { values, id },
      });
    };

export const addProtRad =
  (values, id = null) =>
    (dispatch) => {
      return dispatch({
        type: ADD_PROTECCION_RADIOLOGICA,
        payload: { values, id },
      });
    };

export const addRespInst =
  (values, id = null) =>
    (dispatch) => {
      return dispatch({
        type: ADD_RESPONSABLE_INSTALACION,
        payload: { values, id },
      });
    };

export const addRespUso =
  (values, id = null) =>
    (dispatch) => {
      return dispatch({
        type: ADD_RESPONSABLE_USO,
        payload: { values, id },
      });
    };

export const setEquipoRadiologicoData = (values) => (dispatch) => {
  return dispatch({
    type: SET_EQUIPO_RADIOLOGICO_DATA,
    payload: values,
  });
};

export const removeEquipoRadiologico = (ids) => (dispatch) => {
  return dispatch({
    type: REMOVE_EQUIPO_RADIOLOGICO,
    payload: ids,
  });
};

export const setEquipoRadiologico =
  (values, id = null) =>
    (dispatch) => {
      return dispatch({
        type: SET_EQUIPO_RADIOLOGICO,
        payload: { values, id },
      });
    };

export const postCabecera = (values) => (dispatch) => {
  return dispatch({
    type: POST_CABECERA_RES,
    payload: values,
  });
};

export const postObservaciones = (values) => (dispatch) => {
  return dispatch({
    type: POST_OBSERVACIONES_RES,
    payload: values,
  });
};

export const sendAllResForm = (aux) => (dispatch) => {
  return dispatch({
    type: POST_ALL_RES,
    payload: axios
      .post(`cancerigeno/cargarFormulario`, aux, {
        responseType: "blob",
        headers: {
          Accept: "application/zip",
        },
      })
      .then((response) => {
        let fileName = response?.headers['content-disposition']?.split("filename=")[1];
        return { data: response.data, fileName }
      })
      .catch((error) => Promise.reject(error)),
  });
};

export const getDatosEstablecimiento = (establecimiento) => (dispatch) => {
  return dispatch({
    type: GET_DATOS_ESTABLECIMIENTOS,
    payload: axios
      .get(
        `dependenciaEmpleador/datosBasicos?idDependenciaEmpleador=${establecimiento}`
      )
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const clearPostRes = () => (dispatch) => {
  return dispatch({
    type: CLEAR_POST_RES,
  });
};

export const postSearchedRes = (establecimiento) => (dispatch) => {
  return dispatch({
    type: POST_SEARCHED_RES,
    payload: establecimiento,
  });
};

export const validarDisponibilidadCargaResolucion =
  (establecimiento) => (dispatch) => {
    return dispatch({
      type: GET_VALIDAR_DISPONIBILIDAD_RESOLUCION,
      payload: axios
        .get(
          `cancerigeno/validarDisponibilidadCargaFormulario?idDependenciaEmpleador=${establecimiento}`
        )
        .then((response) => ({ data: response.data }))
        .catch((error) => Promise.reject(error)),
    });
  };

export const getFormularioAnterior =
  (establecimiento) => (dispatch) => {
    return dispatch({
      type: GET_FORMULARIO_ANTERIOR,
      payload: axios
        .get(
          `cancerigeno/formularioAnterior?idDependenciaEmpleador=${establecimiento}`
        )
        .then((response) => ({ data: response.data }))
        .catch((error) => Promise.reject(error)),
    });
  };


export const getFormularioPorId =
  (idDDJJ415) => (dispatch) => {
    return dispatch({
      type: GET_FORMULARIO_POR_ID,
      payload: axios
        .get(
          `cancerigeno/formularioPorId?idDDJJ415=${idDDJJ415}`
        )
        .then((response) => ({ data: response.data }))
        .catch((error) => Promise.reject(error)),
    });
  };



export const clearSearchedEstablecimiento = () => (dispatch) => {
  return dispatch({
    type: CLEAR_SEARCHED_ESTABLECIMIENTO,
  });
};

export const clearRes = () => (dispatch) => {
  return dispatch({
    type: CLEAR_RES,
  });
};

export const getFormulariosPresentados = (establecimiento) => (dispatch) => {
  return dispatch({
    type: GET_FORMULARIOS_PRESENTADOS,
    payload: axios
      .get(
        `dependenciaEmpleador/formulariosAsociados?idDependenciaEmpleador=${establecimiento}`
      )
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const addSustancia = (values, id) => (dispatch) => {
  return dispatch({
    type: ADD_SUSTANCIA,
    payload: { values, id },
  });
};

// Necesita lista de ids
export const removeSustancias = (sustancias) => (dispatch) => {
  return dispatch({
    type: REMOVE_SUSTANCIAS,
    payload: sustancias,
  });
};

export const getSustancias = () => (dispatch) => {
  return dispatch({
    type: GET_SUSTANCIAS,
    payload: axios
      .get("cancerigeno/agentesCancerigenos")
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};
export const getTiposDosimetria = () => (dispatch) => {
  return dispatch({
    type: GET_TIPOS_DOSIMETRIA,
    payload: axios
      .get(`cancerigeno/tiposDosimetria`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getMetodosDosimetria = () => (dispatch) => {
  return dispatch({
    type: GET_METODOS_DOSIMETRIA,
    payload: axios
      .get(`cancerigeno/metodosDosimetria`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const postEquiposRadiologicos = (values) => (dispatch) => {
  return dispatch({
    type: POST_EQUIPO_RADIOLOGICO,
    payload: axios
      .post("cancerigeno/cargarEquipoRadiologicoEstablecimiento", values)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const postDosimetria = (values) => (dispatch) => {
  return dispatch({
    type: POST_DOSIMETRIA,
    payload: values,
  });
};

export const getUnidadesDeMedida = () => (dispatch) => {
  return dispatch({
    type: GET_UNIDADES_MEDIDA,
    payload: axios
      .get("cancerigeno/unidadesMedida")
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getEquiposRadiologicos =
  (idDependenciaEmpleador) => (dispatch) => {
    return dispatch({
      type: GET_EQUIPOS_RADIOLOGICOS,
      payload: axios
        .get(
          `cancerigeno/equiposRadiologicosEstablecimiento?idDependenciaEmpleador=${idDependenciaEmpleador}`
        )
        .then((response) => ({ data: response.data }))
        .catch((error) => Promise.reject(error)),
    });
  };

export const getTiposMetodosProcesamiento = () => (dispatch) => {
  return dispatch({
    type: GET_TIPOS_METODOS_PROCESAMIENTO,
    payload: axios
      .get(`cancerigeno/tiposMetodosProcesamientoImagenes`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getTiposFuentes = () => (dispatch) => {
  return dispatch({
    type: GET_TIPOS_FUENTES,
    payload: axios
      .get(`cancerigeno/tiposFuente`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getTiposEquiposRadiologicos = () => (dispatch) => {
  return dispatch({
    type: GET_TIPOS_EQUIPOS_RADIOLOGICOS,
    payload: axios
      .get(`cancerigeno/tiposEquiposRadiologicos`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getTiposCaracteristicas = () => (dispatch) => {
  return dispatch({
    type: GET_TIPOS_CARACTERISTICAS,
    payload: axios
      .get(`cancerigeno/caracteristicasEquiposRadiologicos`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getTiposRadiacion = () => (dispatch) => {
  return dispatch({
    type: GET_TIPOS_RADIACION,
    payload: axios
      .get(`cancerigeno/tiposRadiacion`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};


export const addPuestoAsociado = (values, id) => (dispatch) => {
  return dispatch({
    type: ADD_PUESTOS_ASOCIADOS,
    payload: { values, id },
  });
};

// Necesita lista de ids
export const removePuestosAsociados = (puestos) => (dispatch) => {
  return dispatch({
    type: REMOVE_PUESTOS,
    payload: puestos,
  });
};


export const getPuestos = (idDependenciaEmpleador) => (dispatch) => {
  return dispatch({
    type: GET_PUESTOS,
    payload: axios
      .get(`cancerigeno/puestosEstablecimiento?idDependenciaEmpleador=${idDependenciaEmpleador}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const postPuesto = (values) => (dispatch) => {
  return dispatch({
    type: POST_EQUIPO_RADIOLOGICO,
    payload: axios
      .post("cancerigeno/cargarPuestoEstablecimiento", values)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getDatosCIUOPuesto = (puesto) => (dispatch) => {
  return dispatch({
    type: GET_DATOS_CIOU_PUESTO,
    payload: axios
      .get(`cancerigeno/datosCIUOPuesto?idPuestoDDJJ415=${puesto}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  })
}

export const getElementosProteccionPersonal = () => (dispatch) => {
  return dispatch({
    type: GET_ELEMENTOS_PROTECCION_PERSONAL,
    payload: axios
      .get(`cancerigeno/elementosProteccionPersonal`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  })
}

export const getMedidasPreventivas = () => (dispatch) => {
  return dispatch({
    type: GET_MEDIDAS_PREVENTIVAS,
    payload: axios
      .get(`cancerigeno/medidasPreventivas`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  })
}




export const addTrabajador = (values, id) => (dispatch) => {
  return dispatch({
    type: ADD_TRABAJADORES,
    payload: { values, id },
  });
};

// Necesita lista de ids
export const removeTrabajadores = (trabajadores) => (dispatch) => {
  return dispatch({
    type: REMOVE_TRABAJADORES,
    payload: trabajadores,
  });
};

export const getSectores = (establecimiento) => (dispatch) => {
  return dispatch({
    type: GET_SECTORES,
    payload: axios
      .get(
        `dependenciaEmpleador/sectores?idDependenciaEmpleador=${establecimiento}`
      )
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getTiposExamenesMedicos = () => (dispatch) => {
  return dispatch({
    type: GET_TIPOS_EXAMENES_MEDICOS,
    payload: axios
      .get(
        `cancerigeno/tiposExamenesMedicos`
      )
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  })
}